export const formErrors = [
  'blank_first_name',
  'blank_last_name',
  'blank_phone',
  'blank_address_1',
  'blank_city',
  'blank_postal_code',
  'blank_answer',
  'invalid_email'
];
